import { useState, useEffect } from "react";
import QuestionForm from "./QuestionForm";
import { getRequest, putRequest, showMessage } from "../../../../config";

const InvestmentReadinessQuestions = () => {
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expandedIndex, setExpandedIndex] = useState(null);
    const [savingIds, setSavingIds] = useState(new Set());

    useEffect(() => {
        fetchQuestions();
    }, []);
    console.log(questions, "questions -----function------> InvestmentReadinessQuestions")
    const fetchQuestions = async () => {
        setLoading(true);
        const response = await getRequest('/modules/investment-readiness/questions');
        if (response?.body?.questions) {
            setQuestions(response.body.questions);
        }
        setLoading(false);
    };

    const handleUpdate = (index, updatedQuestion) => {
        setQuestions(prev => {
            const next = [...prev];
            next[index] = updatedQuestion;
            return next;
        });
    };

    const handleSave = async (index) => {
        const question = questions[index];
        if (!question._id) return;

        setSavingIds(prev => new Set(prev).add(question._id));

        const payload = {
            _id: question._id,
            qDescription: question.qDescription,
            questionType: question.questionType,
            customOptions: question.customOptions,
            predefinedOptionsInfo: question.predefinedOptionsInfo,
            dateInfo: question.dateInfo,
            tooltip: question.tooltip,
            toolboxOffer: question.toolboxOffer,
            riskScores: question.riskScores,
            riskDescription: question.riskDescription,
            recommendDescription: question.recommendDescription,
            attachmentRequired: question.attachmentRequired,
            tags: question.tags,
        };

        const response = await putRequest('/modules/investment-readiness/questions', payload);

        setSavingIds(prev => {
            const next = new Set(prev);
            next.delete(question._id);
            return next;
        });

        if (response?.code === 200 && response.body) {
            setQuestions(prev => {
                const next = [...prev];
                next[index] = response.body;
                return next;
            });
        }
    };

    if (loading) {
        return (
            <div className="tac p3rem">
                <p className="fs0-9rem c15 op60">Loading Investment Readiness questions...</p>
            </div>
        );
    }

    if (!questions.length) {
        return (
            <div className="br12px p3rem tac" style={{
                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                border: '2px dashed #dee2e6'
            }}>
                <p className="fs1-1rem fw500" style={{ color: '#495057', margin: '0 0 0.5rem 0' }}>
                    No Investment Readiness questions found
                </p>
                <p className="fs0-9rem" style={{ color: '#6c757d', margin: 0 }}>
                    Questions with qNo matching &quot;EHE&quot; will appear here
                </p>
            </div>
        );
    }


    return (
        <div className="df fdc" style={{ gap: '0.5rem' }}>
            {questions.map((question, index) => (
                <div key={question._id || index}>
                    <QuestionForm
                        question={question}
                        index={index}
                        moduleKey="EHE"
                        sectionIndex={0}
                        isExpanded={expandedIndex === index}
                        onToggleExpand={() => setExpandedIndex(expandedIndex === index ? null : index)}
                        onUpdate={(updated) => handleUpdate(index, updated)}
                        onRemove={() => { }}
                        hideDelete
                    />
                    {expandedIndex === index && (
                        <div className="df jcfe" style={{ marginTop: '0.5rem', marginBottom: '1rem' }}>
                            <button
                                type="button"
                                onClick={() => handleSave(index)}
                                disabled={savingIds.has(question._id)}
                                style={{
                                    border: 'none',
                                    background: savingIds.has(question._id) ? '#aaa' : '#667eea',
                                    color: 'white',
                                    padding: '10px 24px',
                                    borderRadius: '8px',
                                    fontSize: '0.9rem',
                                    fontWeight: '500',
                                    cursor: savingIds.has(question._id) ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.2s ease'
                                }}
                            >
                                {savingIds.has(question._id) ? 'Saving...' : 'Save Question'}
                            </button>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default InvestmentReadinessQuestions;
